import React, {useState} from "react";
import {
    Edit,
    TabbedForm,
    FormTab,
    TextInput,
    ReferenceInput,
    SelectInput,
    SelectField,
    SelectArrayInput,
    FileField,
    FileInput,
    FormDataConsumer,
    BooleanInput,
    DateInput,
    DateField,
    Toolbar,
    useNotify
} from 'react-admin';
import required from "../helper/Required";
import SaveButtonAware from "../component/SaveButtonAware";
import caServices from "../helper/caServices";
import {Box, Paper, Dialog, DialogActions, DialogContent, DialogContentText} from "@material-ui/core";
import ButtonMui from "@material-ui/core/Button";
import LoadingComponent from "../component/LoadingComponent";
import errorMessage from "../helper/ErrorMessage";
import "../contract_request/styles/main.css"
import ContractIdGForm from "../helper/ContractIdForm";
import MedicalProgramGroupByIdForm from "../helper/MedicalProgramGroupByIdForm";
import medicalPrograms from "../helper/MedicalProgramsGroupped";
import SignComponent from "../component/SignComponent";

const ContractRequestEdit = props => {
    const notify = useNotify();
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [loading, setLoading] = useState(false);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [values, setValues] = useState([]);
    const edrCaption = 'Запису в Єдиному державному реєстрі юридичних осіб, фізичних осіб-підприємців та громадсmких формувань';
    // const agreementText = 'Цією заявою Заявник висловлює бажання укласти договір про реімбурсацію з Національною службою здоров\'я України та підтверджує, що на момент подання цієї заяви Заявник провадить господарську діяльність на підставі ліцензії на провадження господарської діяльності з роздрібної торгівлі лікарськими засобами та відповідає ліцензійним умовам. Заявник усвідомлює, що у разі зміни інформації, зазначеної Заявником у цій заяві та (або) доданих до неї документах Заявник зобов\'язаний повідомити про такі зміни НСЗУ протягом трьох робочих днів з дня настання таких змін шляхом надсилання інформації про такі зміни на електронну пошту dohovir@nszu.gov.ua, з одночасним внесенням таких змін в Систему. Заявник усвідомлює, що законодавством України передбачена відповідальність за подання недостовірної інформації органам державної влади.';
    const agreementText = 'Цією заявою Заявник висловлює бажання укласти договір про реімбурсацію з Національною службою здоров\'я України та підтверджує, що на момент подання цієї заяви Заявник провадить господарську діяльність на підставі ліцензії на провадження господарської діяльності з роздрібної торгівлі лікарськими засобами та відповідає ліцензійним умовам. Заявник усвідомлює, що у разі зміни інформації, зазначеної Заявником у цій заяві та (або) доданих до неї документах Заявник зобов\'язаний повідомити про такі зміни НСЗУ протягом трьох робочих днів з дня настання таких змін шляхом надсилання інформації про такі зміни на електронну пошту reimb@nszu.gov.ua, з одночасним внесенням таких змін в Систему. Заявник усвідомлює, що законодавством України передбачена відповідальність за подання недостовірної інформації органам державної влади.';
    let keyCallbacks = null;

    const keyMounted = (callbacks) => {
        keyCallbacks = callbacks;
    };

    const popupAlert = (message) => {
        setAlertOpen(true);
        setAlertText(message);
    };

    const popupConfirm = (values) => {
        setConfirmOpen(true);

        if (values.newEndDate.substring(0, 10) === values.endDate.substring(0, 10)) {
            values.endDate = null;
        } else {
            values.endDate = values.newEndDate;
        }

        let programIds = [];
        for (let i = 0; i < values.medicalProgramGrouped.length; i++) {
            for (let j = 0; j < medicalPrograms.length; j++) {
                if (medicalPrograms[j].id !== values.medicalProgramGrouped[i]) {
                    continue;
                }

                for (let k = 0; k < medicalPrograms[j].list.length; k++) {
                    programIds.push(medicalPrograms[j].list[k].id);
                }
            }
        }

        values.medicalProgramId = programIds;

        values.id = null;
        values.startDate = null;
        setValues(values)
    };

    const handleAlertClose = () => {
        setAlertOpen(false);
    };

    const handleConfirmClose = () => {
        setConfirmOpen(false);
    };

    const sendRequest = () => {
        setLoading(true);

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                'X-Session': localStorage.getItem('session')
            },
            body: JSON.stringify(values)
        };

        fetch(
            process.env.REACT_APP_API_ENTRYPOINT + '/contract_requests',
            requestOptions
        )
            .then(response => {
                if (response.status >= 400) {
                    return Promise.reject();
                }

                return response.json()
            })
            .then(data => {
                if (data.success) {
                    popupAlert('Запит успішно відправлений.');
                } else {
                    errorMessage(data, popupAlert);
                }

                setLoading(false);
            })
            .catch(() => {popupAlert('Помилка надсилання запиту.'); setLoading(false);});
    };

    const processFileKey = () => {
        let reader = new FileReader();
        reader.onloadend = event => {
            values.keyStore = event.target.result;
            let fileParts = values.sign.title.split('.');
            values.extension = fileParts[fileParts.length - 1];

            sendRequest();
        }

        reader.readAsDataURL(values.sign.rawFile);
    };

    const processStatute = () => {
        if (values.statute?.rawFile) {
            let reader = new FileReader();
            reader.onloadend = event => {
                values.statute = event.target.result;

                if (typeof values.tab ==='undefined' || values.tab === 0) {
                    values.signType = 'file';
                    processFileKey();
                } else if (values.tab === 1) {
                    values.signType = 'hardware';
                    processHardwareKey();
                } else if (values.tab === 2) {
                    values.signType = 'gryada';
                    processGryadaKey(values);
                }
            }

            reader.readAsDataURL(values.statute.rawFile);
        } else {
            if (typeof values.tab ==='undefined' || values.tab === 0) {
                values.signType = 'file';
                processFileKey();
            } else if (values.tab === 1) {
                values.signType = 'hardware';
                processHardwareKey();
            } else if (values.tab === 2) {
                values.signType = 'gryada';
                processGryadaKey(values);
            }
        }
    };

    const processAdditionalData = () => {
        if (values.additionalDocument?.rawFile) {
            let reader = new FileReader();
            reader.onloadend = event => {
                values.additionalDocument = event.target.result;

                processStatute();
            }

            reader.readAsDataURL(values.additionalDocument.rawFile);
        } else {
            processStatute();
        }
    };

    const processHardwareKey = () => {
        keyCallbacks.verify(async (data) => {
            if (!data.keyAgreement?.canBeUsed || !data.signature?.canBeUsed) {
                popupAlert('Помилка зчитування КЕП');
                setLoading(false);
                return;
            }

            try {
                const resp1 = await fetch(
                    process.env.REACT_APP_API_ENTRYPOINT + '/contract_requests?onlySerialize=1',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                            'X-Session': localStorage.getItem('session')
                        },
                        body: JSON.stringify(values)
                    }
                );

                if (resp1.status === 200) {
                    const data = await resp1.json();
                    let id = data.id;
                    keyCallbacks.sign(data.content, async (signed) => {
                        try {
                            const resp2 = await fetch(
                                process.env.REACT_APP_BASE_ENTRYPOINT + '/contract_request/save',
                                {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                                        'X-Session': localStorage.getItem('session')
                                    },
                                    body: JSON.stringify({content: signed.base64Data, id: id})
                                }
                            );

                            const data = await resp2.json();

                            if (data.success) {
                                popupAlert('Запит успішно відправлений.');
                            } else {
                                errorMessage(data, popupAlert);
                            }
                            setLoading(false);
                        } catch (e) {
                            popupAlert('Помилка надсилання запиту');
                            setLoading(false);
                        }
                    });
                }
            } catch (e) {
                popupAlert('Помилка надсилання запиту');
                setLoading(false);
            }

        });
    }

    const processGryadaKey = () => {
        sendRequest();
    };

    const handleSave = () => {
        setConfirmOpen(false);
        processAdditionalData();
    }

    const ContractRequestCreateToolbar = props => (
        <Toolbar {...props}>
            <div className="toolbar-wrapper">
                <div style={{"margin": "30px"}}>
                    <SignComponent {...props} onMounted={callbacks => keyMounted(callbacks)} />
                </div>
                <div className="toolbar-button-section">
                    {loading ? <LoadingComponent /> : <SaveButtonAware onSave={popupConfirm} label="Відправити запит" {...props} />}
                </div>

                <Dialog
                    open={alertOpen}
                    onClose={handleAlertClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-content">
                            {alertText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <ButtonMui onClick={handleAlertClose} variant="contained" color="primary">
                            OK
                        </ButtonMui>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={confirmOpen}
                    onClose={handleConfirmClose}
                    aria-labelledby="confirm-dialog-title"
                    aria-describedby="confirm-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="confirm-dialog-content">
                            Засвідчуючи даний договір кваліфікованим електронним підписом я розумію,
                            про настання певних прав та обов’язків, зрозумів текст договору.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <ButtonMui onClick={handleSave} variant="contained" color="primary">Добре</ButtonMui>
                        <ButtonMui onClick={handleConfirmClose} variant="contained">Відхилити</ButtonMui>
                    </DialogActions>
                </Dialog>
            </div>
        </Toolbar>
    );

    const employeeName = employee => {
        return (employee.party.lastName ? employee.party.lastName + ' ': '')
            + (employee.party.firstName ? employee.party.firstName : '')
            + (employee.party.secondName ? ' ' + employee.party.secondName : '' )
    };

    const MedicalPrograms = props => {
        return (
            <SelectArrayInput {...props} formClassName="tab-content-item" resettable={true} label="Мед. програми"
                              source="medicalProgramGrouped" validate={required.validateRequired}
                              choices={medicalPrograms}
            />
        )
    }

    return (
        <Edit {...props} title="Редагування заявки на договір">
            <TabbedForm toolbar={<ContractRequestCreateToolbar {...props} />} validate={required.validateContractEdit}>
                <FormTab contentClassName="legal-entities-tab-content" label={<span>Загальна інформація <sup>*</sup></span>}>
                    <SelectInput formClassName="tab-content-item" label="На підставе" source="contractorBase" validate={required.validateRequired} choices={[
                        { id: 'Статуту', name: 'Статуту' },
                        { id: 'Домовленості', name: 'Домовленості' },
                        { id: edrCaption, name: edrCaption}
                    ]} />
                    <ReferenceInput
                        formClassName="tab-content-item"
                        label="Підписант з боку аптеки"
                        source="contractorOwnerId"
                        reference="employees"
                        validate={required.validateRequired}
                        filter={{ employee_type: 'OWNER' }}
                    >
                        <SelectInput optionText={employeeName} />
                    </ReferenceInput>
                    <FormDataConsumer formClassName="tab-content-item">
                        {({formData, ...rest}) =>
                            (formData.contractorBase === edrCaption ?
                                <TextInput formClassName="tab-content-item" label="Номер запису у реєстрі *" source="recordNumber" />
                                : null)
                        }
                    </FormDataConsumer>
                    <FormDataConsumer formClassName="tab-content-item">
                        {({formData, ...rest}) =>
                            (formData.contractorBase === edrCaption ?
                                <DateInput formClassName="tab-content-item" label="Дата внесення до реєстру *" source="recordDate" />
                                : null)
                        }
                    </FormDataConsumer>
                    <TextInput formClassName="tab-content-item" label="Номер банківського рахунку (IBAN)" source="payerAccount" validate={required.validateRequiredIban} />
                    <TextInput formClassName="tab-content-item" label="Назва банку" source="bankName" validate={required.validateRequired} />
                    <SelectField formClassName="tab-content-item" label="Тип договору" source="type" validate={required.validateRequired} choices={[
                        { id: 'REIMBURSEMENT', name: 'Договір по реімбурсації' }
                    ]} />
                    <SelectField formClassName="tab-content-item" label="Підтип договору" source="idForm" validate={required.validateRequired} choices={ContractIdGForm} />
                    <MedicalPrograms formClassName="tab-content-item" {...props} />
                    {/*<SelectArrayInput {...props} formClassName="tab-content-item" resettable={true} label="Мед. програми"*/}
                    {/*    source="medicalProgramGrouped" validate={required.validateRequired}*/}
                    {/*    choices={selectedPrograms()}*/}
                    {/*/>*/}
                    {/*<SelectArrayInput formClassName="tab-content-item" resettable={true} label="Мед. програми" source="medicalPrograms" validate={required.validateRequired}*/}
                    {/*                  choices={[*/}
                    {/*                      {id: '63c1f32f-c8f4-4f5b-81a9-79b8452d6545', name: 'Серцево-судинні та цереброваскулярні захворювання, цукровий діабет 2-го типу та хронічні хвороби нижніх дихальних шляхів'},*/}
                    {/*                      {id: '857588d8-9e12-4935-96c4-b08e95d19dce', name: 'Інсуліни картриджи та шприц ручки з доплатою'},*/}
                    {/*                      {id: '8efe29df-18bd-4d49-8995-c3f7e44d9e12', name: 'Інсуліни картриджи та шприц ручки безоплатно'},*/}
                    {/*                      {id: 'e9c6beeb-b19f-4b97-b42a-020c5c996c56', name: 'Інсуліни з доплатою'},*/}
                    {/*                      {id: '7335a30e-61f2-42b0-9ed4-2afe847bba16', name: 'Інсуліни безоплатно'},*/}
                    {/*                      {id: 'cda113e4-b8dd-4ec4-a878-3d1c7eae49da', name: 'Інсуліни флакони безоплатно'},*/}
                    {/*                      {id: '14e19712-b443-4391-b0f7-aba8e8662459', name: 'Нецукровий діабет'},*/}
                    {/*                      {id: 'f217889f-736f-462c-8f8b-ed99edddb3be', name: 'Розлади психіки та поведінки'},*/}
                    {/*                      {id: '9d94a21b-ec70-4b91-946a-981f4db8d2b9', name: 'Епілепсія'}*/}
                    {/*                  ]}*/}
                    {/*/>*/}
                    <div formClassName="tab-content-item"></div>

                    <DateField formClassName="tab-content-item" label="Дата початку дії" source="startDate" {...props}/>
                    <DateInput formClassName="tab-content-item" label="Дата завершення дії" source="newEndDate" />

                    <Box style={{width:"700px"}} {...props}>
                        <FileInput source={'statute'} label={""} placeholder={"Статут компанії (PDF)"} accept="application/pdf">
                            <FileField source="src" title="title" />
                        </FileInput>
                    </Box>
                    <Box style={{width:"700px"}} {...props}>
                        <FileInput source={'additionalDocument'} label={""} placeholder={"Додаткові документи (PDF)"} accept="application/pdf" >
                            <FileField source="src" title="title" />
                        </FileInput>
                    </Box>

                    <TextInput disabled formClassName="tab-content-item-consent-text" label="Текст угоди" source="consentText" validate={required.validateRequired} fullWidth={true} multiline={true}
                               initialValue={agreementText}
                    />
                    <BooleanInput formClassName="tab-content-item-last" label="Підтверджую" source="consent" fullWidth={true} />
                </FormTab>
            </TabbedForm>
        </Edit>
    );
};

export default ContractRequestEdit;
